import React, { Component } from 'react';
import ReactHtmlParser from 'react-html-parser';
import { Ref } from "./App.js";
import SDate from "./sdate.js";
import AnimateHeight from 'react-animate-height';

export class Comments extends Component {
  page = 1;
  pagesCount = 1;
  min = 0;
  maxRec = 10;

  state = { 
    fields: [],
    rows: [],
    files: {},
    text: "",
    showSmileys: false,
    searchText: "",
    cssHeight: "0"
  }

  componentDidMount() {
    Ref.timers.chatTimer = setInterval(() => {
      const p = this.props;
      if(p.activity && p.display == "dblock") {
        this.update(p, true, false);
      }
    }, 60*1000);
  }

  async componentWillReceiveProps(p) {
    if(p.display == "dnone") {
      this.setState({cssHeight: "0"});
    }

    if(this.props.activity !== p.activity || this.props.data !== p.data) {
      this.state.searchText = "";
      this.maxRec = 10;
      this.page = 1;
      await this.update(p, false);

      setTimeout(() => {
        this.setState({cssHeight: "auto"});
      }, 1000);
    }
  }

  update = async(p = this.props, fetch = true, clearText = true)=> {   
    const json = fetch ? await window.fetchj("/chat/", {
      iParentRecordID: (p.activity || ""),
      fulltextSearch: this.state.searchText,
      iPageNo: this.page,
      iRowsPerPage: this.maxRec 
    }) : p.data

    const rows = p.activity === null ? [] : (json.data || []);

    const state = {
      fields: json.fields,
      rows: rows,
      //transform: "scaleY(1)"
    }

    const rowInfo = rows[0] || {};
    this.pagesCount = rowInfo.pgCnt || 1;
    this.records = rowInfo.totCnt;
    this.min = this.page * this.maxRec - this.maxRec;

    if(clearText) {
      state.files = {};
      state.loading = false;
      state.text = "";
      state.showSmileys = false;
      state.allowSend = false;
    }

    setTimeout(() => {
      this.setState(state)
    }, 1);
  }

  parseComment(c) {
    const smileys = {
      ":)": "bg-01_usmev",
      ":D": "bg-02_velkyUsmev",
      ":(": "bg-03_smutny",
      ":|": "bg-04_rovny",
      ":o": "bg-05_prekvapeni",
      ";)": "bg-06_mrkat",
      ":[": "bg-07_tvare",
      ":A": "bg-08_andel",
      ":P": "bg-09_jazyk", 
      ":*": "bg-10_pusa",

      ":-)": "bg-01_usmev",
      ":-D": "bg-02_velkyUsmev",
      ":-(": "bg-03_smutny",
      ":-|": "bg-04_rovny",
      ":-o": "bg-05_prekvapeni",
      ";-)": "bg-06_mrkat",
      ":-[": "bg-07_tvare",
      ":-A": "bg-08_andel",
      ":-P": "bg-09_jazyk", 
      ":*": "bg-10_pusa",
    }

    const url = window.location.hostname == "localhost" ? "http://localhost:8080" : "";

    c = c.replace(/\n/g, "<br>").replace(/\<att\:(.*)\:(.*)\>/g, (find,guid,filename) =>
      `<a class="priloha" href='${url}/prilohy/detail/${guid}/${filename}'>${filename}</a>`
    ).replace(/(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,})/gi, link => 
      `<a class="href" href='${link}'>${link}</a>`
    )

    for(let [key,val] of Object.entries(smileys)) {
      c = c.split(key).join(`<span title="${key}" class='ik16 ${val}'></span>`);
    }
    return ReactHtmlParser(c);
  }

  viewComments =()=> (
    this.state.rows.sort((a,b) => SDate(b.insertDate) - SDate(a.insertDate)).map(m => 
      <div className="komentar" onClick={this.commentClick}>
        <div className="jmeno">{m.author}</div>
        <div className="datum">{SDate(m.insertDate).format("d.M.yy H:mm")}</div>
        <div className="zprava">{this.parseComment(m.msgText)}</div>
      </div>
    )
  )

  commentClick =e=> {
    if(e.target.className == "priloha") {
      Ref.Dialog.current.preview(e.target.href);
    }

    if(e.target.className == "href") {
      window.open(e.target.href);
    }
    
    e.preventDefault();
    e.stopPropagation();
  }

  write =e=> {
    this.props.chr.komentar = true;

    this.setState({
      text: e.target.value,
      allowSend: true
    });
  }

  send =async ()=> {
    let fileData = [];
    const time = SDate.time;
    const files = [];
    const data = { idAktivita: this.props.activity };
    const json = {
      agenda: "activity_chat_list",
      data: [data]
    }

    for(let file of Object.values(this.state.files)) {
      files.push({
        name: file.name,
        size: file.size,
        data: (await this.toBase64(file))
      });
    }

    if(files.length) {
      fileData = this.fileChunks(files[0].data);
      data.ownRecId = files[0].name + "_" + time;
      data.attNameExt = files[0].name;
    }

    if(this.state.text === "" && !data.attNameExt) return;

    Ref.loading = true;
    this.setState({ loading: true })

    try {
      //odesle komentar pokud neobsahuje prilohu
      if(!fileData.length && this.state.text) {
        data.msgText = this.state.text;
        await window.fetchj("/json", json);
      }

      //odesle casti souboru a nakonec komentar
      for(let i=0;i<fileData.length;i++) {
        (this.state.files[files[0].name]||{}).uploaded = (i/(fileData.length-1)*100);
        this.setState(s=>s);
        data.partNo = i+1;
        data.attBlob = fileData[i];
        data.lastPart = i === (fileData.length - 1);

        if(this.state.text && data.lastPart) {
          data.msgText = this.state.text;
        }

        await window.fetchj("/json", json);
      }

      this.props.chr.komentar = false;
      this.props.chr._ext = false;
    }
    catch(e) {
      console.error("chyba", e.message);
    }

    await this.update(this.props);
    await Ref.AtchList.current.update(this.props.activity);
    Ref.loading = false;
  }

  fileChunks(b64, size = 500*1024) { //500kB
    const chunks = [];
    let str = b64;
    
    do {
      chunks.push(str.substring(0, size));
      str = str.substring(size, str.length);
    } while (str.length > 0);
  
    return chunks;
  };

  toBase64 = file => new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result.split(',').pop());
    reader.onerror = error => reject(error);
  });

  addAtch =async e=> {
    this.state.files = {};

    for(let file of e.target.files) {
      if(file.size > 20*1024*1024) {
        Ref.InfoDialog.current.show("Max. velikost souboru musí být 20 MB.");
      }
      else {
        this.state.files[file.name] = file;
        this.props.chr._ext = true;
      }
    }

    e.target.value = null;
    this.setState({allowSend: true});
  }

  printSize(size) {
		var sizes = "kMGT" //PEZY";

		for(let i=sizes.length-1;i>=0;i--) {
			if(size >= Math.pow(1024, i+1)) return (size/Math.pow(1024, i+1)).toFixed(2) + " " + sizes[i] + "B";
		}

		return size + " B";
	}

  getFiles() {
    return Object.values(this.state.files).map(file => {
      const upl = file.uploaded || 0;

      return (
        <span className="fileInfo" style={{background: `linear-gradient(90deg, #9EFF5C ${upl}%, #FFF ${upl}%)`}} title={"Velikost: " + this.printSize(file.size)}>
          <span className="fName">{file.name}</span>
          <span className="icon fas fa-times" onClick={e=> this.removeFile(file.name)}></span>
        </span>
      )
    })
  }

  removeFile(name) {
    delete this.state.files[name];
    this.props.chr._ext = !!Object.values(this.state.files).length;
    this.setState(s => s);
  }

  addSmiley =e=> {
    if(!e.target.title) return;

    const curPosition = document.getElementById("komentar").selectionStart;
    this.props.chr.komentar = true;

    this.setState({ 
      showSmileys: false,
      allowSend: true,
      text: (this.state.text.substr(0, curPosition) + " " + e.target.title + " " + this.state.text.substr(curPosition)).trim()
    });
  }

  getPages = () => {
    let r = [];
    let page = this.page || 1;

    let lastPage = this.pagesCount;//Math.ceil(this.records / this.max);
    let pageMin = 1;//page-2 > 0 ? page-2 : 1;
    let pageMax = 1;//page+2 < lastPage ? page+2 : lastPage;

    const li = (i, active) => 
      <li className={"paginate_button" + (active ? " active" : "")} onClick={() => this.setPage(i)}><a>{i}</a></li>

    if(page > 3 && lastPage > 3) {
      r.push(li(1))
      r.push(li("..."))
    }

    for(let i=pageMin;i<=pageMax;i++) {
      r.push(li(i, page == i))
    }

    if(page+2 < lastPage) {
      r.push(li("..."))
      r.push(li(lastPage))
    }

    return r;
  }

  setFilter = max => {
    this.maxRec = max;
    this.min = 0;
    this.page = 1;
    return this.update();
  }
  
  switchSmileys =e=> {
    this.setState({ showSmileys: !this.state.showSmileys});
  }

  showSmileys =e=> {
    e.stopPropagation();
    this.setState({ showSmileys: true});
  }

  search =async e=> {
    this.setState({ searchText: e.target ? e.target.value : e })
    
    if(this.timerHandle) clearTimeout(this.timerHandle);
    
    this.timerHandle = setTimeout(() => {
      this.page = 1;
      this.update();
    }, 800);
  }

  setPage = (page, plus = 0) => {
    page += plus;

    if(page < 1 || page > this.pagesCount || page == "...") return;
    this.page = page;

    return this.update();
  }

  getPages = () => {
    let r = [];
    let page = this.page;

    let lastPage = this.pagesCount;//Math.ceil(this.records / this.max);
    let pageMin = page-2 > 0 ? page-2 : 1;
    let pageMax = page+2 < lastPage ? page+2 : lastPage;

    const li = (i, active) => 
      <li className={"paginate_button" + (active ? " active" : "")} onClick={() => this.setPage(i)}><a>{i}</a></li>

    if(page > 3 && lastPage > 3) {
      r.push(li(1))
      r.push(li("..."))
    }

    for(let i=pageMin;i<=pageMax;i++) {
      r.push(li(i, page == i))
    }

    if(page+2 < lastPage) {
      r.push(li("..."))
      r.push(li(lastPage))
    }

    return r;
  }

  searchClear =async e=> {
    this.state.searchText = "";

    return this.update();
  }

  render() {
    let recordsFrom = this.min + 1;
    let recordsTo = this.min + this.state.rows.length;

    if(recordsTo < recordsFrom) recordsFrom = recordsTo;

    return (
      <div className={"komentare" + (this.state.loading ? " loading" : "")}>
        {this.props.canAddChat ? <>
          Komentáře
          <div id="komentarOddil">
            <div id="modalPoznamka">
              <textarea placeholder="Napsat komentář ..." type="text" id="komentar" className="form-control" value={this.state.text} onInput={e=> this.write(e)} />
            </div>
            <div class="lista">
              <span id="sendComment" className="btn btn-primary" disabled={!this.state.allowSend} title="Odeslat komentář" onClick={e=> this.send()}>{"\uf075"} Odeslat</span>
              <label id="labelFile">
                <div id="fileInput" title="Vložit přílohu ke komentáři" className="btn btn-warning"><i className="fa fa-upload"></i> Příloha</div>
                <input id="addAttachment" type="file" style={{display: "none"}} onInput={e=> this.addAtch(e)} />
              </label>
              <span title="Smajlíky" class="ik32 bg-04_rovny smajlik" onClick={this.switchSmileys} onMouseOver={this.showSmileys}></span>
              <span id="smajliky" onClick={this.addSmiley} className={this.state.showSmileys ? "zobrazit" : ""}>
                <span title=":)"  class="ik32 bg-01_usmev"></span>
                <span title=":D"  class="ik32 bg-02_velkyUsmev"></span>
                <span title=":("  class="ik32 bg-03_smutny"></span>
                <span title=":|"  class="ik32 bg-04_rovny"></span>
                <span title=":o"  class="ik32 bg-05_prekvapeni"></span>
                <span title=";)"  class="ik32 bg-06_mrkat"></span>
                <span title=":["  class="ik32 bg-07_tvare"></span>
                <span title=":A"  class="ik32 bg-08_andel"></span>
                <span title=":P"  class="ik32 bg-09_jazyk"></span>
                <span title=":*"  class="ik32 bg-10_pusa"></span>
              </span>
              <span id="files">{this.getFiles()}</span>
            </div>
          </div>
          <div className="dataTables_wrapper seznam">
            <div className="dataTables_length col-sm-6">
              <label>Zobrazit <select className="form-control input-sm m-wrap small" value={this.maxRec} onInput={e => this.setFilter(e.target.value)}>
                  <option value="2">2</option>
                  <option value="5">5</option>
                  <option value="10">10</option>
                  <option value="25">25</option>
                  <option value="50">50</option>
                  <option value="100">100</option>
                </select> záznamů</label>
            </div>
            <div className="dataTables_filter">
              <label>
                <input type="search" className="form-control input-sm" placeholder="Hledat" value={this.state.searchText} onInput={this.search} />
                  <button type="button" className="btn btn-orange btn-sm searchclrbtn" onClick={this.searchClear}><i className="fa fa-times"></i></button>
              </label>
            </div>
            <AnimateHeight id='example-panel' duration={1000} height={this.state.cssHeight}>
              {this.viewComments()}
            </AnimateHeight>
            <div className="dataTables_info">
              Zobrazeno {recordsFrom} do {recordsTo} z {this.records || "0"} záznamů
            </div>
            <div className="dataTables_paginate paging_simple_numbers">
              <ul className="pagination">
                <li className="paginate_button prev" onClick={() => this.setPage(this.page, -1)}><a>Předchozí</a></li>
                  {this.getPages(this.page, Math.ceil(this.maxRecords / this.maxRec))}  
                <li className="paginate_button next" onClick={() => this.setPage(this.page, 1)}><a>Další</a></li>
              </ul>
            </div>
          </div>
        </> : []
        }   
      </div>
    );
  }
}